import { render, staticRenderFns } from "./CurationLoading.vue?vue&type=template&id=915fed48&scoped=true&"
import script from "./CurationLoading.vue?vue&type=script&lang=js&"
export * from "./CurationLoading.vue?vue&type=script&lang=js&"
import style0 from "./CurationLoading.vue?vue&type=style&index=0&id=915fed48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915fed48",
  null
  
)

export default component.exports